import { ICustomerForeignIpInformation } from '../../model/models/customer/customer-foreign-ip-information.interface';

export class ForeignIpGeolocationMapper {

  static fromEntity(entity: any): ICustomerForeignIpInformation | null {
    if (!entity || typeof entity !== 'object') {
      return null;
    }

    const source = ForeignIpGeolocationMapper.pick(entity, 'customerForeignIpInformation') || entity;
    if (!source || typeof source !== 'object') {
      return null;
    }

    const reasons = ForeignIpGeolocationMapper.pick(source, 'foreignIpEvaluationReasons');
    const blocked = ForeignIpGeolocationMapper.pick(source, 'isTransactionBlockDueToForeignRestrictions');
    if (reasons === undefined && blocked === undefined) {
      return null;
    }

    const reasonList: any[] = Array.isArray(reasons) ? reasons : [];
    return {
      foreignIpEvaluationReasons: reasonList.map((r) => String(r)),
      foreignRegistrationCountryIso: ForeignIpGeolocationMapper.str(ForeignIpGeolocationMapper.pick(source, 'foreignRegistrationCountryIso')),
      currentSigninIpCountryIso: ForeignIpGeolocationMapper.str(ForeignIpGeolocationMapper.pick(source, 'currentSigninIpCountryIso')),
      isTransactionBlockDueToForeignRestrictions: blocked === true,
      isForeignIpTransaction: ForeignIpGeolocationMapper.pick(source, 'isForeignIpTransaction') === true,
      isDomesticIpTransaction: ForeignIpGeolocationMapper.pick(source, 'isDomesticIpTransaction') === true,
      customerForeignStreakTransactionCount: Number(ForeignIpGeolocationMapper.pick(source, 'customerForeignStreakTransactionCount')) || 0,
      customerForeignTransactionStreakStartDate: ForeignIpGeolocationMapper.str(ForeignIpGeolocationMapper.pick(source, 'customerForeignTransactionStreakStartDate')),
      userDeviceTimeZone: ForeignIpGeolocationMapper.str(ForeignIpGeolocationMapper.pick(source, 'userDeviceTimeZone')),
      currentGeolocationCountryIso: ForeignIpGeolocationMapper.str(ForeignIpGeolocationMapper.pick(source, 'currentGeolocationCountryIso')),
    };
  }

  private static pick(source: any, camelKey: string): any {
    if (source[camelKey] !== undefined) {
      return source[camelKey];
    }
    const pascalKey = camelKey.charAt(0).toUpperCase() + camelKey.slice(1);
    return source[pascalKey];
  }

  private static str(value: any): string | null {
    const isEmpty = value === undefined || value === null || value === '';
    if (isEmpty) {
      return null;
    }
    return String(value);
  }
}



// WEBPACK FOOTER //
// ./src/providers/foreign-ip-geolocation/foreign-ip-geolocation.mapper.ts